import { Consumer, createConsumer } from "@rails/actioncable";

import { AppConfig } from "./AppConfig";

let singletonConsumer: Consumer;

export function createCable(): Consumer {
  if (!singletonConsumer) {
    const url = `${AppConfig.API_URL}/cable`;
    singletonConsumer = createConsumer(url);
  }

  return singletonConsumer;
}
